'use strict';

/**
 *
 * @name: rootAnalytics
 *
 */

function RootAnalyticsFactory($analytics, $rootScope, $location) {

  'ngInject';

  function associatedStory(page, ass) {

    var properties = {
      eventAction: 'Associated story',
      eventPoints: 0,
      attributes: {
        label: page + ' | ' + ass.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack(page, properties);
  }

  function buttons(action, label, post) {

    var properties = {
      eventAction: label + ' | ' + action,
      eventPoints: 0,
      attributes: {
        label: post.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Video Interactions', properties);
  }

  function topNavButton(button) {

    var properties = {
      eventAction: button,
      eventPoints: 0,
      attributes: {
        label: $location.path()
      }
    };

    return $analytics.eventTrack('Main navigation', properties);
  }

  function language(lang) {

    var properties = {
      eventAction: lang,
      eventPoints: 0,
      attributes: {
        label: ''
      }
    };

    return $analytics.eventTrack('Language', properties);
  }

  function socialNetwork(source, network) {

    if (network && network.match(/^icon-/)) {

      network = network.replace('icon-', '');
    }

    var properties = {
      eventAction: 'Follow Nowness',
      eventPoints: 0,
      attributes: {
        label: source + ' | ' + network
      }
    };

    return $analytics.eventTrack('Social Networks', properties);
  }

  function videoAM(moduleName, moduleTitle, video) {
    console.log(123)
    var dontReloadOn = [
      'series landing page',
      'series player',
      'category player'
    ];

    if (dontReloadOn.indexOf(moduleName) === -1) {

      void 0;
      $rootScope.forceRouterSync = true;
    }

    var properties = {
      eventAction: $location.path() + ' | ' + moduleName + ' | ' + moduleTitle,
      eventPoints: 0,
      attributes: {
        label: video.id + ' | ' + video.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Video Access Methods', properties);
  }

  function latestStories(story, index) {

    var positions = [
      'Main',
      'Bottom left',
      'Bottom right'
    ];

    var properties = {
      eventAction: 'Stories of the day | ' + positions[index],
      eventPoints: 0,
      attributes: {
        label: story.id + ' | ' + story.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Video Access Methods', properties);
  }

  function videoAMPersistent(shortcut, video) {

    if (shortcut === 'mostViewed') {

      shortcut = 'most popular';
    }

    if (shortcut === 'items') {

      shortcut = 'queue';
    }

    if (shortcut === 'selected') {

      shortcut = 'selected for you';
    }

    if (shortcut === 'recent') {

      shortcut = 'most recent';
    }

    var properties = {
      eventAction: shortcut,
      eventPoints: 0,
      attributes: {
        label: video.id + ' | ' + video.translations[$rootScope.lang].title
      }
    };

    return $analytics.eventTrack('Video Access Methods', properties);
  }

  return {
    latestStories: latestStories,
    associatedStory: associatedStory,
    buttons: buttons,
    topNavButton: topNavButton,
    language: language,
    socialNetwork: socialNetwork,
    videoAM: videoAM,
    videoAMPersistent: videoAMPersistent,
  };
}

export default RootAnalyticsFactory;
// }



// WEBPACK FOOTER //
// ./app/pages/root/root-analytics.factory.js